import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { Company } from "../types";

async function searchCompaniesRequest(
  workspaceId: string,
  keyword: string,
): Promise<Company[]> {
  const queryParams = new URLSearchParams();
  queryParams.set("keyword", keyword);

  const { companies } = await get(
    `workspaces/${workspaceId}/companies?${queryParams.toString()}`,
  );
  return companies;
}

export default function useCompaniesSearch(keyword: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { companiesSearchKeys } = getQueryKeys(workspaceId);

  const { data: companies, isLoading: isLoadingCompanies } = useQuery({
    queryKey: companiesSearchKeys.list(keyword),
    queryFn: () => searchCompaniesRequest(workspaceId, keyword),
    enabled: !!keyword,
  });

  return { companies, isLoadingCompanies };
}
